import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { Banner } from "../../../../ui/organisms/banner"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { BusinessRegisterUpdate, BusinessRegisterValidation, resetBusinessRegisterUpdateStatus, resetBusinessRegisterValidationStatus } from "../slice"
import { EditRegistroForms } from "./forms"
import { EditRegistroRight } from "./right"

export function EditRegistroAziendale() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const registerState = useAppSelector(state => state.register)
    const sessionState = useAppSelector(state => state.session)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (registerState.businessRegisterUpdateStatus === 'successfully'
        ) {
            dispatch(resetBusinessRegisterUpdateStatus())
            setShowSuccess(true)
        }
    }, [registerState.businessRegisterUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    useEffect(() => {
        if (registerState.businessRegisterValidationStatus === 'successfully') {
            dispatch(resetBusinessRegisterValidationStatus())
            dispatch(BusinessRegisterUpdate({ body: registerState.businessRegisterUpdateRequest, id: registerState.businessRegisterIdToUpdate }))
        }
    }, [registerState.businessRegisterValidationStatus])

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CLIENTI}
                breadcrumbItems={['Gestione Clienti', 'Registri Aziendali', 'Modifica Registro Aziendale']}
                noPaddingLat
                headerLabel="Registri Aziendali"
                headerIcon={
                    <ArrowLeftIcon onClick={() => navigate('/registriAziendali')} color={colors.brandPrimary[50]} size={0} />
                }
                headerChildren={
                    <div className="flex items-center h-full w-full justify-end">
                        <ButtonComponent
                            iconPosition='off'
                            variant='solid'
                            color='orange'
                            onClick={() => dispatch(BusinessRegisterValidation(registerState.businessRegisterUpdateRequest))}
                            size='sm'
                            label='Modifica'
                        />
                    </div>
                }
            >
                <div className="flex flex-col w-full h-full overflow-hidden">
                    {
                        showSuccess &&
                        <div className="px-6 pt-3 pb-1">
                            <div className="rounded-xl border-2 border-green-200 bg-green-50 px-6 py-5 text-left">
                                <span className="block text-sm font-semibold text-green-700">
                                    Dati salvati correttamente.
                                </span>
                            </div>
                        </div>
                    }
                    <div className="flex flex-1 overflow-hidden">
                        <div className="flex-[0.7] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200">
                            <EditRegistroForms />
                        </div>
                        <div className="flex-[0.3] overflow-y-auto bg-white">
                            <RightBar disabled={false}>
                                <EditRegistroRight />
                            </RightBar>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    return (
        <Layout menuItem={MenuItems.GESTIONE_CLIENTI} breadcrumbItems={['Gestione Clienti', 'Registri Aziendali']}
            noPaddingLat
            headerLabel={"Registri aziendali"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}